'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLabel = getLabel;
exports.labelExists = labelExists;
exports.dispatchEvent = dispatchEvent;
/**
 * Function that returns the text for the key prop provided from the label. If labels object is undefined or the key prop is not present then a default value in the format '[<key>]' is returned.
 * @param {object} labels The object containing the key value pairs of labels
 * @param {string} labelKey The key prop for the labels object
 * @param {string} defaultValue If the key does not exist or the value is null or undefined then return the defaultValue
 */
function getLabel(labels, labelKey, defaultValue) {
  labels = labels || {};
  return labels[labelKey] || defaultValue || '';
}

/**
 * Returns if a key exists in the labels object
 * @param {object} labels The object containing the key value pairs of labels
 * @param {string} labelKey The key prop for the labels object
 */
function labelExists(labels, labelKey) {
  return labels ? labels.hasOwnProperty(labelKey) : false;
}

/**
 * Helper method to dispatch a custom event for enabling a pub-sub model.
 * @param {string} eventName The name of the event that a subscriber uses to subscribe to the event.
 * @param {object} details Additional information in the form of a javascript object that should be passed to the event. It is available through the event.detail property.
 */
function dispatchEvent(eventName, details) {
  if (CustomEvent && eventName && eventName.length > 0) {
    var props = {
      bubbles: true,
      cancelable: false
    };
    if (details) {
      props.detail = details;
    }
    var changeEvent = new CustomEvent(eventName, props);
    document.dispatchEvent(changeEvent);
  }
}